import React from 'react';

import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@clef/client-library';

export enum AccessMode {
  Private,
  Public,
}

type ConfirmVisibilityChangeDialogProps = {
  open: boolean;
  accessMode: AccessMode;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmVisibilityChangeDialog = ({
  open,
  accessMode,
  onCancel,
  onConfirm,
}: ConfirmVisibilityChangeDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('Switch project mode')}</DialogTitle>
      <DialogContent>
        <Box>
          {accessMode === AccessMode.Public
            ? t('Are you sure you want to switch this project from private to public?')
            : t('Are you sure you want to switch this project from public to private?')}
        </Box>
        <Box>
          {accessMode === AccessMode.Public
            ? t(
                'After it’s done, all memebers in your organzation will be able to have full access of the project.',
              )
            : t(
                'After it’s done, this project will only be available to you and project members. You can invite more members later.',
              )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button id="switch-access-cancel" color="primary" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} id="switch-access-done">
          {t(
            accessMode === AccessMode.Private
              ? t('Yes, Switch to Private')
              : t('Yes, Switch to Public'),
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
